import { Avatar } from 'components/common';
import { StatItem } from 'components/common/stats';

import type { IconProp } from 'components/common/icons/Icon';

interface Props {
  icon: IconProp;
  iconBefore?: boolean;
  label: React.ReactNode;
  style?: React.CSSProperties;
  value: React.ReactNode;
}

const StatItemWithIcon = ({
  icon,
  iconBefore = false,
  label,
  style,
  value
}: Props) => {
  return (
    <div className="stat-item" style={style}>
      {iconBefore ? (
        <Avatar fontSize="1.3rem" icon={icon} padding="10px 0" size="36px" />
      ) : null}

      <StatItem
        align="left"
        label={label}
        labelBefore={true}
        value={value}
        valueStyle={{ fontSize: '2.4rem' }}
      />

      {!iconBefore ? (
        <Avatar fontSize="1.3rem" icon={icon} padding="10px 0" size="36px" />
      ) : null}

      <style jsx>{`
        .stat-item {
          align-items: center;
          display: flex;
          justify-content: space-between;
        }
      `}</style>
    </div>
  );
};

export default StatItemWithIcon;
